module.exports = __webpack_public_path__ + "real-estate.53caf5866c83bc74fd6a.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/real-estate/webfont/real-estate.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/real-estate/webfont/real-estate.svg
// module chunks = styles